import BatteryStatus from './BatteryStatus';

export default class PhysicalSampleDiscovery {
    public id: number;
    public macAddress: string;
    public studioId: number;
    public studioName: string;
    public firstSeenAt: string;
    public lastSeenAt: string;
    public isOnline: boolean | undefined;
    public inDrawer: boolean | undefined;
    public isLightOn: boolean | undefined;
    public firmwareVersion: string | undefined;
    public pcb: string | undefined;
    public batteryVoltage: number;
    public batteryStatus: BatteryStatus;

    // Values selected by the producer before confirming the discovery.
    public selectedSampleId: number | undefined;
    public selectedStudioId: number | undefined;
    public confirming = false;

    constructor(data: { [key: string]: any }) {
        this.id = data['id'];
        this.macAddress = data['macAddress'];
        this.studioId = data['studioId'];
        this.studioName = data['studioName'];
        this.firstSeenAt = data['firstSeenAt'];
        this.lastSeenAt = data['lastSeenAt'];
        this.isOnline = data['isOnline'];
        this.inDrawer = data['inDrawer'];
        this.isLightOn = data['isLightOn'];
        this.firmwareVersion = data['firmwareVersion'] || undefined;
        this.pcb = data['pcb'] || undefined;
        this.batteryVoltage = data['batteryVoltage'] || 0;
        this.batteryStatus = data['batteryStatus'] || BatteryStatus.UNKNOWN;
        this.selectedStudioId = this.studioId;
    }
}

